import styled from "styled-components";

export const StyledAnonymousQuestion = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-top: 10px;

  .title {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 900;
    font-size: 24.18px;
    line-height: 24.18px;
    letter-spacing: -0.33px;
    text-align: center;
    margin: 0;
  }

  .subtitle {
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: -0.22px;
    text-align: center;
    margin: 0;
  }

  .question {
    width: 100%;
    min-height: 166px;
    padding: 16px 14px;
    border-radius: 10px;
    border: 1px solid #7e8aad33;
    background-color: #f7f8fa;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: -0.22px;
    text-align: right;
    resize: none;
    box-sizing: border-box;
    color: #7e8aad;
  }

  .question::placeholder {
    color: #7e8aad;
  }

  .question:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(126, 138, 173, 0.2);
  }

  .submit-button {
    width: 129px;
    height: 30px;
    margin-top: 14px;
    border-radius: 100px;
    background-color: #004ef7;
    color: #ffffff;
    border: none;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: -0.22px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s, opacity 0.2s;
  }

  .submit-button:not(:disabled):hover {
    background-color: #0041cc;
  }

  .submit-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
